
import styled from 'styled-components';

import { Icon } from '../../../../../../../../../ui-kit';


const mixin = {
  width: '100%',
  boxShadow: '0 0 1px 4px #cbefe8',
  border: '3px solid #22bda3',
  borderRadius: '5px',
  background: 'transparent',
  boxSizing: 'border-box',
  padding: '5px',
  marginBottom: 'unset'
};

export const Row = styled.div.attrs((props) => ({
  style: {
    display: 'flex',
    ...props.style
  }
}))`${(props) => props.computedStyle}`;

export const Col = styled.div.attrs((props) => ({
  style: {
    ...props.style,
    ...(!props.isVisible ? { opacity: 0.25 } : {})
  }
}))`${(props) => props.computedStyle}`;

export const InputBase = styled.textarea.attrs(
  (props) => ({
    style: {
      ...props.style,
      ...mixin,
      ...(!props.isVisible ? { opacity: 0.25 } : {})
    }
  }))`${(props) => props.computedStyle}`;

export const ImageBase = styled.img.attrs((props) => ({
  style: {
    ...props.style,
    ...(props.canEdit ? {
      boxShadow: '0 0 1px 4px #cbefe8',
      border: '3px solid #22bda3',
      borderRadius: '5px'
    } : {})
  }
}))`${(props) => props.computedStyle}`;

export const EditableRecipient = styled.div.attrs(
  (props) => ({
    style: {
      marginTop: '40px',
      ...props.style,
      ...mixin,
      ...(!props.isVisible ? { opacity: 0.25 } : {})
    }
  }))`${(props) => props.computedStyle}`;

export const ClickableDiv = styled.div.attrs((props) => ({
  style: { ...props.style }
}))`
  opacity: ${(props) => !props.isVisible && '0.25'}
`;

export const NoEditModeBlock = styled.span.attrs(
  (props) => ({
    ...props,
    style: {
      background: '#000',
      borderRadius: '5px',
      bottom: '-30px',
      color: '#fff',
      fontSize: '14px',
      fontWeight: '500',
      left: 0,
      padding: '3px 8px',
      position: 'absolute',
      width: '250px',
      zIndex: 10
    }
  }))`${(props) => props.computedStyle}`;


export const SelectedColorBlock = styled.span.attrs(
  (props) => ({
    style: {
      ...props.style,
      border: '1px solid #fff',
      bottom: '-5px',
      display: 'inline-block',
      height: '3px',
      left: '20px',
      position: 'absolute',
      width: '22px'
    }
  }))`${(props) => props.computedStyle}`;

/* $FlowFixMe */
export const ArrowBlock = styled(Icon)`
  margin-left: 15px;
  ${({ active }) => active && `
  transform: rotate(180deg);
  `}
`;

export const SubOptionBlock = styled.div.attrs((props) => ({
  style: {
    ...props.style
  }
}))`
  position: absolute;
  top: 40px;
  z-index: 9;
  `;

export const RecipientElement = styled.div`
  display: flex;
  min-width: 250px;
  background: #fff;
  color: #000;
  padding: 14px 15px;
  box-shadow: 0px 3px 7px #585555;
  font-weight: 300;
  font-size: 16px;
  border-radius: 5px;
  margin-top: 2px;
  :first-child {
    margin-top: 20px;
  }
  & span:last-child {
    margin: 0 0 0 auto;
  }
`;

export const InputElementBlock = styled.div`
  padding-top: 0;
  display: flex;
  min-width: 400px;
  .input-element {
    display: flex;
    min-width: 400px;
    position: relative;
    .input-container {
      position: relative;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border: 1px solid #d4d9e2 !important;
    }
    .icon-container {
      position: absolute;
      right: 15px;
      top: 15px;
    }
  }
  .button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
`;

export const OptionsMainBlock = styled.div.attrs(
  (props) => ({
    style: {
      position: 'absolute',
      zIndex: 4,
      left: props.centerAlign ? '45%' : '0',
      ...(props.isRowOptions ? {
        top: '100%'
      } : {})
    }
  }))`${(props) => props.computedStyle}`;

export const OptionsListElement = styled.p.attrs(
  (props) => ({
    style: {
      ...props.style
    }
  }))`
  border-right: 1px solid #fff;
  display: flex;
  height: 25px;
  margin: 0;
  min-height: 25px;
  padding: 0 24px;
  position: relative;
`;

export const BlockAction = styled.div`
  left: 0;
  position: absolute;
  z-index: 9;
  top: 10px;
`;

export const BlockActionList = styled.ul`
  background: #000;
  border-radius: 4px;
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0 6px;
`;

export const BlockActionListElement = styled.li`
  cursor: pointer;
  padding: 10px 0;
  position: relative;
  &:last-child {
    p {
      border: unset;
    }
  }
  &:hover, &.active {
    &::before {
      background-color: #2BD0B3;
      bottom: 0;
      content: '';
      height: 100%;
      left: 0;
      margin: auto;
      position: absolute;
      right: 0;
      top: 0;
      width: calc(100% - 15px);
    }
  }
`;

export const RelativeBlock = styled.div`
  position: relative;
`;
export const RelativeSpanBlock = styled.span`
  position: relative;
`;